import { graphql } from '@/gql';
import type { AssignOperatorToGroceryMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const assignOperatorToGrocery = async ({ orderId, operatorId }: AssignOperatorToGroceryMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AssignOperatorToGrocery($orderId: String!, $operatorId: String!) {
        assignOperatorToGrocery(orderId: $orderId, operatorId: $operatorId) {
          id
        }
      }
    `),
    variables: {
      orderId,
      operatorId,
    },
  });

  return !!response.data?.assignOperatorToGrocery;
};
